// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"br_dL","title":"br_S","eyebrow":"br_H"};